import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import '@/sass/customer.scss'
import VueSocialSharing from 'vue-social-sharing'
import VueCardFormat from 'vue-credit-card-validation'

import './permisson'

Vue.use(VueCardFormat)

Vue.use(VueSocialSharing)

Vue.use(require('vue-moment'))

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
